"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetryableHttpClient = void 0;
const dp_http_client_lib_1 = require("@greatmindsorg/dp-http-client-lib");
const default_http_client_1 = require("../http/default-http.client");
class RetryableHttpClient extends dp_http_client_lib_1.RetryableHttpClient {
    static newInstance(options, retryOptions) {
        return new RetryableHttpClient(new default_http_client_1.DefaultHttpClient(options), retryOptions);
    }
}
exports.RetryableHttpClient = RetryableHttpClient;
//# sourceMappingURL=retryable-http.client.js.map